/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDobbiesStoreBasedNotifications containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum searchRadiusUnit {
    miles = 'miles',
    kilometers = 'kilometers'
}

export interface IDobbiesStoreBasedNotificationsConfig extends Msdyn365.IModuleConfig {
    shouldShowYouMightAlsoLike?: boolean;
    discountAppliedInCartMessage?: string;
    productBundlesOrderSummaryText?: string;
    maxAllowedNumberOfTimesForNotificationsToShow?: number;
    storeBasedNotifications?: INotificationPropertiesData[];
    lookupRadius: number;
    searchRadiusUnit?: searchRadiusUnit;
    latitude?: number;
    longitude?: number;
    allEnglandStores?: string[];
    allScotlandStores?: string[];
    allNorthernIrelandStores?: string[];
    allWalesStores?: string[];
    urlsToHideStoreBasednotifications?: string[];
}

export interface IDobbiesStoreBasedNotificationsResources {
    resourceKey: string;
}

export interface IDobbiesStoreBasedNotificationsProps<T> extends Msdyn365.IModule<T> {
    resources: IDobbiesStoreBasedNotificationsResources;
    config: IDobbiesStoreBasedNotificationsConfig;
    slots: {
        notificationProductsSlot: React.ReactNode[];
    };
}

export const enum NotificationPropertiesNotificationType {
    event = 'event',
    products = 'products'
}

export interface INotificationPropertiesData {
    storeName: string;
    notificationBannerImage: string;
    notificationBannerHeading?: string;
    notificationBannerSubHeading?: string;
    notificationHeading: string;
    notificationType?: NotificationPropertiesNotificationType;
    activePoints?: undefined[];
    notificationContent: Msdyn365.RichText;
    notificationFooter: Msdyn365.RichText;
    notificationStartDate?: string;
    notificationShowEndDate?: string;
}
